import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/configuracion/firmado-de-documentos';

/**
 * GET Firmados de Documentos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getFirmadosDeDocumentos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Firmado de Documento por ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getFirmadoDeDocumento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Firmado de Documento
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFirmadoDeDocumento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Firmado de Documento
 * @param {number} id
 * @param {object} values
 * @param {string} message mensaje de éxito
 * @returns {Promise<object|boolean>}
 */
export const patchFirmadoDeDocumento = async (id, values, message = 'Editado correctamente') => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, message);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Firmado de Documento
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteFirmadoDeDocumento = async (id) => {
  try {
    await API.delete(`${baseURI}/${id}`);
    onSuccess({}, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Empleado (vía Dato Operacional) y Área vigentes de una Plaza
 * @param {number} plaza
 * @returns {Promise<object|null>}
 */
export const getDatosDePlazaFirmado = async (plaza) => {
  try {
    const response = await API.get(`${baseURI}/datos-de-plaza`, { params: { plaza } });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Módulos de Documentos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getModulosDeDocumentos = async (params) => {
  try {
    const response = await API.get('/configuracion/modulos-de-documentos', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Documentos Operativos
 * @param {object} params p.ej. { modulo }
 * @returns {Promise<object[]>}
 */
export const getDocumentosOperativos = async (params) => {
  try {
    const response = await API.get('/configuracion/documentos-operativos', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Firma
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeFirma = async (params) => {
  try {
    const response = await API.get('/catalogos/tipo-de-firma', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Impresión
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeImpresion = async (params) => {
  try {
    const response = await API.get('/catalogos/tipo-de-impresion', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Roles de Firma (Catálogo de Finalidad de Firmado)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRolesDeFirma = async (params) => {
  try {
    const response = await API.get('/catalogos/catalogo-de-finalidad-de-firmado', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
